import { render } from "./CouponsList.vue?vue&type=template&id=b678dd48&scoped=true"
import script from "./CouponsList.vue?vue&type=script&lang=js"
export * from "./CouponsList.vue?vue&type=script&lang=js"

import "./CouponsList.vue?vue&type=style&index=0&id=b678dd48&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kamon\\Documents\\Workspace\\ECOUPONS\\coupons-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b678dd48"]])

export default __exports__